import { render, staticRenderFns } from "./search-validation-details.vue?vue&type=template&id=65541c95&scoped=true&"
import script from "./search-validation-details.vue?vue&type=script&lang=js&"
export * from "./search-validation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65541c95",
  null
  
)

export default component.exports